import {
  CheckboxWithLabel,
  CheckboxWithLabelProps,
} from '@/shadcn-ui/checkbox-with-label';
import React from 'react';
import ColorSwatch from './color-swatch';
import { cn } from '@/shadcn-ui/utils';

interface FilterOptionCheckboxProps extends CheckboxWithLabelProps {
  color?: string;
  categoryName?: string;
}

const FilterOptionCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxWithLabel>,
  FilterOptionCheckboxProps
>(({ color, categoryName, ...props }: FilterOptionCheckboxProps, ref) => {
  return color ? (
    <CheckboxWithLabel
      ref={ref}
      classNameCheckbox="border-[2px] border-flexcar-neutral80 shadow-inputShadow h-[24px] w-[24px] data-[state=checked]:border-flexcar-blue40 data-[state=checked]:bg-flexcar-blue40"
      inputKey={`${categoryName}-color-swatch-${color}`}
      {...props}
      label={
        <div className="flex w-full items-center justify-between">
          <p
            className={cn('body', {
              'cursor-not-allowed text-flexcar-neutral80': props.disabled,
            })}
          >
            {props.label}
          </p>
          <ColorSwatch
            color={color}
            className={cn({
              'cursor-not-allowed opacity-5': props.disabled,
            })}
          />
        </div>
      }
    />
  ) : (
    <CheckboxWithLabel
      ref={ref}
      classNameCheckbox="border-[2px] border-flexcar-neutral80 shadow-inputShadow h-[24px] w-[24px] data-[state=checked]:border-flexcar-blue40 data-[state=checked]:bg-flexcar-blue40"
      inputKey={`${categoryName}-${props.value}`}
      {...props}
    />
  );
});
FilterOptionCheckbox.displayName = 'FilterOptionCheckbox';

export { FilterOptionCheckbox };
